module.exports = __webpack_public_path__ + "img/809.dba886be.gif";